import { pascalCase } from "change-case";

/**
 * Convert kebab-case to PascalCase for React component names
 */
export function kebabToPascalCase(kebabName: string): string {
  // Remove .svg extension if present
  const nameWithoutExt = kebabName.replace(/\.svg$/, "");
  return pascalCase(nameWithoutExt);
}

/**
 * Get component filename from icon name
 */
export function getComponentFilename(
  iconName: string,
  extension: "tsx" | "jsx",
): string {
  const componentName = kebabToPascalCase(iconName);
  return `${componentName}.${extension}`;
}
